import React, { useState } from 'react';
import { X } from 'lucide-react';
import { recentWorkGallery } from '../mock';

const GalleryCard = ({ item, onOpen }) => (
  <button
    type="button"
    onClick={onOpen}
    data-testid={`recent-work-item-${item.id}`}
    className="group relative bg-white rounded-xl overflow-hidden border border-slate-200 shadow-md hover:shadow-xl transition-all duration-300 text-left focus:outline-none focus:ring-2 focus:ring-blue-600"
  >
    <div className="relative h-64 overflow-hidden">
      <img
        src={item.image}
        alt={item.title}
        loading="lazy"
        className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-slate-900/70 via-slate-900/0 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
    </div>
    <div className="p-5">
      <h3 className="text-lg font-bold text-slate-900 mb-1">{item.title}</h3>
      <p className="text-slate-600 text-sm">{item.description}</p>
    </div>
  </button>
);

const Lightbox = ({ item, onClose }) => (
  <div
    data-testid="recent-work-lightbox"
    onClick={onClose}
    className="fixed inset-0 z-[100] bg-slate-900/90 backdrop-blur-sm flex items-center justify-center p-4 sm:p-8 cursor-zoom-out"
  >
    <button
      type="button"
      onClick={onClose}
      data-testid="recent-work-lightbox-close"
      aria-label="Close image"
      className="absolute top-5 right-5 bg-white/10 hover:bg-white/20 text-white rounded-full p-2 transition-colors"
    >
      <X size={24} />
    </button>
    <div
      onClick={(e) => e.stopPropagation()}
      className="relative max-w-5xl w-full max-h-[90vh] flex flex-col items-center cursor-default"
    >
      <img
        src={item.image}
        alt={item.title}
        className="max-w-full max-h-[80vh] object-contain rounded-lg shadow-2xl"
      />
      <div className="mt-4 text-center text-white">
        <h3 className="text-xl font-bold">{item.title}</h3>
        <p className="text-white/80 text-sm mt-1">{item.description}</p>
      </div>
    </div>
  </div>
);

const RecentWorkGallery = () => {
  const [lightboxItem, setLightboxItem] = useState(null);

  return (
    <section
      id="recent-work"
      data-testid="recent-work-section"
      className="py-24 bg-slate-50 border-t border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="inline-block text-blue-600 font-semibold text-sm uppercase tracking-wider mb-3">
            Latest Jobs
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">Recent Work</h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            A look at some of our latest plumbing and roofing projects across Melbourne — tap any image to view larger.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {recentWorkGallery.map((item) => (
            <GalleryCard key={item.id} item={item} onOpen={() => setLightboxItem(item)} />
          ))}
        </div>
      </div>

      {lightboxItem && <Lightbox item={lightboxItem} onClose={() => setLightboxItem(null)} />}
    </section>
  );
};

export default RecentWorkGallery;
